"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurManifesto() {
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    value: "5 YRS",
    label: "Community"
  }, {
    value: "1.2K+",
    label: "Active Builders"
  }, {
    value: "450+",
    label: "Open Projects"
  }];
  return <section data-section-id="5010" id="our-manifesto" className="bg-background text-foreground relative overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="flex flex-col lg:flex-row lg:items-stretch">
        {}
        <div ref={imgRef} className={`relative w-full lg:w-3/5 transition-all duration-1000 ease-out ${imgVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <div className="relative h-[60vh] sm:h-[70vh] lg:h-[85vh] lg:border-r lg:border-border/60">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/code_hub_hackathon_workspace.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/code_hub_hackathon_workspace.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/code_hub_hackathon_workspace.png-wvc-sizes" alt="Developers collaborating at a hackathon in a modern tech workspace" loading="lazy" decoding="async" className="h-full w-full object-cover grayscale" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent pointer-events-none" />

            {}
            <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 flex items-center gap-3 font-mono text-[11px] md:text-xs tracking-widest uppercase text-foreground">
              <span className="inline-block size-2" style={{
              backgroundColor: "var(--primary)"
            }} />
              <span style={{
              color: "var(--primary)"
            }}>
                NODE_ID: 88.204.11.04
              </span>
            </div>

            {}
            <div className="absolute top-6 left-6 md:top-8 md:left-8 font-mono text-[11px] tracking-widest uppercase text-foreground/70">
              BUILD / 2024
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`w-full lg:w-2/5 px-6 sm:px-10 lg:pl-24 lg:pr-12 py-16 lg:py-20 transition-all duration-1000 delay-150 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="font-mono text-xs tracking-[0.25em] uppercase mb-10" style={{
          color: "var(--primary)"
        }}>MANIFESTO</div>

          {}
          <h2 className="font-default font-black uppercase leading-[0.95] tracking-tight text-5xl sm:text-6xl lg:text-[72px] mb-12">
            <span className="block">Code</span>
            <span className="block">
              Hub
              <span style={{
              color: "var(--primary)"
            }}>_</span>
            </span>
          </h2>

          {}
          <div className="h-px w-full bg-border mb-10" />

          {}
          <div className="font-default text-[19px] leading-[1.7] text-foreground/85 max-w-prose" style={{
          fontFamily: "var(--font-default)"
        }}>
            <p>
              <span className="float-left font-default font-normal mr-3 mt-1" style={{
              fontFamily: "var(--font-default)",
              fontSize: "5rem",
              lineHeight: "0.85",
              color: "var(--foreground)"
            }}>
                W
              </span>
              e believe that technology is a collaborative craft, not a solitary pursuit. At Code Hub, we provide the infrastructure for builders to iterate, fail, and ship together. Our community is built on the foundation of open-source principles, peer-to-peer mentorship, and the relentless pursuit of technical excellence. From weekly deep-dive workshops to late-night project sprints, we create the environment where ideas transition into production. We don't just write code; we build the future of our local tech ecosystem. Join a network of developers, designers, and hardware enthusiasts dedicated to pushing the boundaries of what's possible in our shared digital space.
            </p>
          </div>

          {}
          <div className="mt-14 border-t border-b border-border">
            <div className="grid grid-cols-3 divide-x divide-border">
              {stats.map((stat, i) => <div key={i} data-index={i} className="py-6 pr-4 first:pl-0 pl-4 sm:pl-6 first:pl-0">
                  <div className="font-default font-bold text-3xl sm:text-4xl leading-none tracking-tight">
                    {stat.value}
                  </div>
                  <div className="font-mono text-[10px] sm:text-[11px] tracking-[0.2em] uppercase mt-3 text-foreground/60">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div className="mt-12">
            <Link to="/JoinUsPage" className="group inline-flex items-center gap-3 font-mono text-xs tracking-[0.25em] uppercase text-foreground">
              <span className="relative inline-block">
                Download Toolkit
                <span className="absolute left-0 -bottom-1 h-px w-0 group-hover:w-full transition-all duration-500 ease-out" style={{
                backgroundColor: "var(--primary)"
              }} />
              </span>
              <ArrowUpRight className="size-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" style={{
              color: "var(--primary)"
            }} />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}